import React from 'react';
import { StopOutlined, ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuth } from '../../../contexts/AuthProvider';
import { getDefaultRoute } from '../../../utils/getDefaultRoute';
import {
  getSessionDisplayEmail,
  getSessionDisplayName,
} from '../../../utils/sessionDisplayName';

const InsufficientPermissions: React.FC = () => {
  const { hasPermission, user } = useAuth();
  const { user: auth0User } = useAuth0();
  const navigate = useNavigate();

  const displayName = getSessionDisplayName(auth0User, user);
  const displayEmail = getSessionDisplayEmail(auth0User, user);

  const handleGoHome = () => {
    navigate(getDefaultRoute(hasPermission), { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-800/30 p-8">
        {/* Top bar */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200 transition-colors"
          >
            <ArrowLeftOutlined />
            Go Back
          </button>
          <img
            src="/ScoutUsLight.png"
            alt="ScoutUs Logo"
            className="h-6 w-auto"
          />
        </div>

        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto w-16 h-16 rounded-full border-[1.5px] border-amber-500/30 bg-amber-500/10 flex items-center justify-center mb-6">
            <StopOutlined className="text-2xl text-amber-400" />
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-white mb-2">
            Insufficient Permissions
          </h1>
          <p className="text-sm text-slate-400 mb-6">
            This section requires additional permissions that are not assigned to your current role.
          </p>
        </div>

        {/* User card */}
        <div className="rounded-xl border border-slate-700 bg-slate-800/50 p-4 mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full border border-slate-700 bg-slate-800 flex items-center justify-center flex-shrink-0">
              {user?.profile_image ? (
                <img src={user.profile_image} alt="Profile" className="w-full h-full rounded-full object-cover" />
              ) : (
                <UserOutlined className="text-slate-500" />
              )}
            </div>
            <div className="text-left min-w-0">
              <p className="text-sm font-medium text-white truncate">
                {displayName}
              </p>
              <p className="text-xs text-slate-400 truncate">
                {displayEmail ?? '—'}
              </p>
            </div>
            {user?.roles?.[0] && (
              <span className="ml-auto inline-flex px-2.5 py-1 text-xs font-medium rounded-full bg-slate-700 text-slate-300 border border-slate-600">
                {user.roles[0]}
              </span>
            )}
          </div>
        </div>

        {/* Home button */}
        <button
          onClick={handleGoHome}
          className="inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 text-sm font-medium rounded-lg border-[1.5px] border-slate-700 text-slate-200 bg-slate-800 hover:border-slate-500 transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default InsufficientPermissions;
